import React from "react";

export default function AboutUs() {
  return (
    <section className="about-page">
      <div className="about-card">
        <div className="section-title-row">
          <h1 className="about-title">About us</h1>
        </div>

        <div className="about-content">
          <p>Καλώς ήρθατε στη σελίδα του ΤΑΨΙ Web Radio!</p>

          <p>
            <strong>«Η Μεθοδευμένη μας Αποτυχία»</strong>
          </p>

          <p>
            Είμαστε μια παρέα φίλων που αποφάσισε ότι το να εκτίθεται δημόσια
            είναι πολύ πιο φθηνό από το να πάει σε ψυχολόγο. Πολλοί μας
            ρωτούν: «Πώς καταφέρατε να μαζέψετε τόσους ανθρώπους με τόσο λίγο
            ταλέντο στον ίδιο χώρο;» Η απάντηση είναι η πειθαρχία. Χρειάστηκαν
            χρόνια προπόνησης για να μπορούμε να μιλάμε πάνω από τα intro των
            τραγουδιών με τέτοια ακρίβεια, ώστε να καταστρέφουμε κάθε ίχνος
            μουσικής απόλαυσης.
          </p>

          <p>
            <strong>Οι Βασικές μας Αρχές (The Unofficial Guide):</strong>
          </p>

          <ol>
            <li>Η Ευγένεια πάνω απ' όλα: Αν μας στείλετε μήνυμα ότι η μουσική είναι χάλια, θα σας ζητήσουμε συγγνώμη. Μετά θα την παίξουμε ξανά, απλώς και μόνο επειδή η ευγένεια δεν συνεπάγεται απαραίτητα και υπακοή.</li>
            <li>Τεχνική Αρτιότητα: Θεωρούμε «επιτυχημένη εκπομπή» οποιαδήποτε φορά που δεν πήρε κάτι φωτιά.</li>
            <li>Η Playlist: Επιμελημένη με την προσοχή ενός ανθρώπου που ψάχνει τα κλειδιά του μέσα σε μια σκοτεινή τσάντα. Υπάρχει μια δομή, αλλά κανείς μας δεν την έχει δει ακόμα.</li>
          </ol>

          <p>
            <strong>«Η Επιστήμη του να Μην Ξέρεις τι κάνεις»</strong>
          </p>

          <p>
            Πολλοί σταθμοί επενδύουν σε πανάκριβα μικρόφωνα, ηχομόνωση κλπ.
            Εμείς επιλέξαμε έναν διαφορετικό δρόμο. Επενδύσαμε κυρίως σε μπύρες
            και φραπέδες, εσωτερικά αστεία που δεν καταλαβαίνει κανείς και μια
            ακλόνητη πίστη ότι αν πατήσουμε αρκετά κουμπιά ταυτόχρονα, κάτι θα
            ακουστεί στον αέρα.
          </p>

          <p>
            <strong>Τι να περιμένετε από εμάς:</strong>
          </p>

          <ol>
            <li>Μουσικές επιλογές: Τόσο αμφίβολες, που θα σας κάνουν να ελέγξετε αν έχετε αυτιά ή όχι.</li>
            <li>Σχόλια: Με την ελπίδα ότι κανείς δεν μας ακούει.</li>
            <li>Τεχνική ποιότητα: Αν ακούτε ένα παράξενο βουητό, μάλλον είπαμε πολλές αλήθειες.</li>
          </ol>

          <p>
            <strong>«Μεγαλείο»</strong>
          </p>

          <p>Για να μην λέμε πολλά...</p>

          <p>
            <strong>ΤΑΨΙ Web Radio εδώ! Ακούτε μόνο καλομαγειρεμένη μουσική! Ψηθείτε...</strong>
          </p>
        </div>
      </div>
    </section>
  );
}
